export default "__VITE_ASSET__DZTSjVMO__"